module.exports = __webpack_public_path__ + "img/link-taobao.4c06a685.e47a4455.png";